export default __webpack_public_path__ + "static/icn-opensource-c3b1de36f3bbceefe34b89f901b959b8.svg";